(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(1596);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
;// CONCATENATED MODULE: ./utils/requests/request.ts

const get = (url)=>{
    return axios/* default.get */.Z.get(url);
};

;// CONCATENATED MODULE: ./utils/requests/rayongboard/404.ts

const getCustom404 = ()=>{
    return get("".concat("https://api.rayongboard.com", "/api/custom404?populate=image"));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./pages/404.tsx







const Custom404 = (param)=>{
    let { image  } = param;
    const [image404, setImage404] = (0,react.useState)("/uploads/default_026_df0f5889f7.webp");
    const [firstPath, setFirstPath] = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const lang = router.locale;
    const path = router.asPath;
    (0,react.useEffect)(()=>{
        onInit();
    }, []);
    const onInit = async ()=>{
        const firstPath = path.startsWith("/blogs");
        setFirstPath(firstPath);
        await getCustom404().then((custom404Data)=>{
            var _custom404Data_data_data, _custom404Data_data_data_attributes, _custom404Data_data_data_attributes_image, _custom404Data_data_data_attributes_image_data;
            if ((_custom404Data_data_data = custom404Data.data.data) === null || _custom404Data_data_data === void 0 ? void 0 : (_custom404Data_data_data_attributes = _custom404Data_data_data.attributes) === null || _custom404Data_data_data_attributes === void 0 ? void 0 : (_custom404Data_data_data_attributes_image = _custom404Data_data_data_attributes.image) === null || _custom404Data_data_data_attributes_image === void 0 ? void 0 : (_custom404Data_data_data_attributes_image_data = _custom404Data_data_data_attributes_image.data) === null || _custom404Data_data_data_attributes_image_data === void 0 ? void 0 : _custom404Data_data_data_attributes_image_data.attributes.url) {
                var _custom404Data_data_data1, _custom404Data_data_data_attributes1, _custom404Data_data_data_attributes_image1, _custom404Data_data_data_attributes_image_data1;
                setImage404((_custom404Data_data_data1 = custom404Data.data.data) === null || _custom404Data_data_data1 === void 0 ? void 0 : (_custom404Data_data_data_attributes1 = _custom404Data_data_data1.attributes) === null || _custom404Data_data_data_attributes1 === void 0 ? void 0 : (_custom404Data_data_data_attributes_image1 = _custom404Data_data_data_attributes1.image) === null || _custom404Data_data_data_attributes_image1 === void 0 ? void 0 : (_custom404Data_data_data_attributes_image_data1 = _custom404Data_data_data_attributes_image1.data) === null || _custom404Data_data_data_attributes_image_data1 === void 0 ? void 0 : _custom404Data_data_data_attributes_image_data1.attributes.url);
            }
        }).catch((err)=>{
            console.error("getCustom404 error:", err);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "404 Not Found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "404 Not Found"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:title",
                        content: "404 Not Found"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "h-screen",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "h-screen flex",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container px-4 m-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-4xl h-64 md:h-96 mb-12 mx-auto",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    className: "h-full w-full rounded-lg object-cover",
                                    src: "".concat("https://api.rayongboard.com").concat(image404),
                                    alt: "404-not-found-image",
                                    width: 896,
                                    height: 384
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-xs font-bold text-gray-200 uppercase",
                                        children: "Error 404"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "mb-2 text-4xl lg:text-5xl font-bold font-heading",
                                        children: "Page not found"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-6 text-lg text-gray-500 leading-loose",
                                        children: "Sorry! We are unable to find the page you are looking for"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-wrap justify-center",
                                        children: [
                                            firstPath ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "px-6 py-2 mr-4 bg-gray-500 hover:bg-gray-600 text-sm leading-loose text-gray-50 font-semibold rounded",
                                                href: "/".concat(lang, "/blogs"),
                                                children: "Go back to Blogs"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                className: "px-6 py-2 mr-4 bg-gray-500 hover:bg-gray-600 text-sm leading-loose text-gray-50 font-semibold rounded",
                                                href: "/".concat(lang),
                                                children: "Go back to Homepage"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: "px-6 py-2 border hover:border-gray-400 text-sm font-semibold leading-loose rounded",
                                                onClick: router.reload,
                                                children: "Try Again"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var _404 = (Custom404); // export async function getStaticProps({ locale }: { locale: string }) {
 //   let props: Custom404Props = {
 //     image: null,
 //   };
 //   await getCustom404()
 //     .then((custom404Data) => {
 //       props.image =
 //         custom404Data.data.data?.attributes?.image?.data?.attributes.url ||
 //         "/uploads/default_026_67eccef8f1.webp";
 //     })
 //     .catch((err) => {
 //       console.error("getCustom404 error:", err);
 //     });
 //   return {
 //     props: props,
 //   };
 // }


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [640,154,774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);